module.exports = __webpack_public_path__ + "img/bag.67ab8fa7.svg";